import React from 'react';
import { Modal, Avatar, Typography, Button, Row, Col, Divider, Tag, Space } from 'antd';
import { UserOutlined, InfoCircleOutlined, GlobalOutlined, VideoCameraOutlined, AppstoreOutlined, EyeOutlined, ClockCircleOutlined, MessageOutlined, PhoneOutlined } from '@ant-design/icons';
import ModelWrapper from '../../modal/ModelWrapper';
import moment from 'moment';

const { Title, Text } = Typography;

const AppointmentsDetailModal = ({ visible, setVisible, selectedPatient }) => {
    return (
         <ModelWrapper
        show={visible}
        setShow={setVisible}
        title={
          <div className="row-flex flex-column">
            <div className="font-18 font-semibold text-primary">
              Patient Appointment Details
            </div>
          </div>
        }
        footer={null}
        width={650}
        keyClose={false}
        onCancel={() => setVisible(false)}
        className="custom-detail-modal calendar-page-container"
      >

  {selectedPatient && (
                    <div className="modal-inner" style={{ 
                        maxHeight: '70vh', 
                        overflowY: 'auto',
                        display: 'flex',
                        flexDirection: 'column'
                    }}>
                        <div className="modal-header-gradient" style={{ 
                            padding: '20px', 
                            margin: '0px 20px',
                            position: 'sticky',
                            top: 0,
                            zIndex: 10
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 24 }}>
                                <Avatar 
                                    size={50} 
                                    icon={<UserOutlined />} 
                                    style={{ 
                                        border: '4px solid rgba(255,255,255,0.3)', 
                                        boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                        background: 'rgba(255,255,255,0.2)' 
                                    }} 
                                    src={selectedPatient.avatar} 
                                />
                                <div>
                                    <div style={{ margin: 0, color: "white", fontWeight: 700, fontSize: '22px' }}>{selectedPatient.patientName}</div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 4 }}>
                                        <Tag style={{ background: 'rgba(255,255,255,0.2)', border: 'none', color: 'white', borderRadius: 4 }}>
                                            ID: {selectedPatient.patientId}
                                        </Tag>
                                       
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="modal-body" style={{ 
                            padding: '24px',
                            flex: 1,
                            overflowY: 'auto'
                        }}>
                            <Row gutter={[24, 24]}>
                                <Col span={24}>
                                    <div className="info-section">
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
                                            <InfoCircleOutlined style={{ color: '#7c3aed' }} />
                                            <Text strong style={{ fontSize: 14 }}>Basic Information</Text>
                                        </div>
                                        <div className="info-grid">
                                            <div className="info-item">
                                                <span className="info-label">Email</span>
                                                <span className="info-value">{selectedPatient.patientEmail || 'N/A'}</span>
                                            </div>
                                            <div className="info-item">
                                                <span className="info-label">Phone</span>
                                                <span className="info-value">
                                                    {selectedPatient?.patientPhone 
                                                        ? `${selectedPatient.patientPhone.countryCode} ${selectedPatient.patientPhone.number}` 
                                                        : 'N/A'}
                                                </span>
                                            </div>
                                            <div className="info-item">
                                                <span className="info-label">Appointment Date</span>
                                                <span className="info-value">
                                                    {moment(selectedPatient.date).format('MMM DD, YYYY')}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col span={24}>
                                    <div className="info-section">
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
                                            <GlobalOutlined style={{ color: '#7c3aed' }} />
                                            <Text strong style={{ fontSize: 14 }}>Assignment Details</Text>
                                        </div>
                                        <div className="info-grid">
                                            <div className="info-item">
                                                <span className="info-label">Scheduled By</span>
                                                <Tag color="purple" style={{ margin: 0, fontSize: 11 }}>{selectedPatient.scheduledBy}</Tag>
                                            </div>
                                            <div className="info-item">
                                                <span className="info-label">Total Assigned</span>
                                                <span className="info-value">{selectedPatient.totalAssigned || 0}</span>
                                            </div>
                                            {/* <div className="info-item">
                                                <span className="info-label">Videos Watched</span>
                                                <span className="info-value">{selectedPatient.watchedCount || 0}</span>
                                            </div>
                                            <div className="info-item">
                                                <span className="info-label">Completion</span>
                                                <span className="info-value" style={{ color: '#10b981' }}>
                                                    {Math.round((selectedPatient.watchedCount / selectedPatient.totalAssigned) * 100) || 0}%
                                                </span>
                                            </div> */}
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                            <Divider orientation="left" style={{ margin: '32px 0 16px' }}>
                                <Space><VideoCameraOutlined /> Video Content Details</Space>
                            </Divider>
                            
                            <div className="video-list-container">
                                {selectedPatient.videos?.map((video, vIdx) => (
                                    <div key={vIdx} className="video-item-card" style={{ padding: '12px 16px' }}>
                                        <div className="video-icon" style={{ borderRadius: '8px' }}><VideoCameraOutlined /></div>
                                        <div style={{ flex: 1 }}>
                                            <div style={{ fontWeight: 700, fontSize: 14 }}>{video.videoName}</div>
                                            <Text type="secondary" style={{ fontSize: 12 }}>Assigned: {moment(video.scheduledTime).format('MMM DD, YYYY')}</Text>
                                        </div>
                                        <div>
                                            {video.isWatched ? (
                                                <Tag color="success" icon={<EyeOutlined />} style={{ borderRadius: 12, padding: '0 12px' }}>Watched</Tag>
                                            ) : (
                                                <Tag color="processing" icon={<ClockCircleOutlined />} style={{ borderRadius: 12, padding: '0 12px' }}>In Progress</Tag>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="modal-footer" style={{ 
                            padding: '10px 24px', 
                            background: 'var(--secondary-bg)',
                            position: 'sticky',
                            bottom: 0,
                            zIndex: 10
                        }}>
                            <Space size="middle">
                                <Button size="large" onClick={() => setVisible(false)} style={{ borderRadius: 8, minWidth: 100 }}>Close</Button>
                                {/* <Button size="large" icon={<PhoneOutlined />} style={{ borderRadius: 8 }}>Call</Button> */}
                               
                            </Space>
                        </div>
                    </div>
                )}
      </ModelWrapper>
    );
};

export default AppointmentsDetailModal; 